import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
  // 空排行业版
  {
    path: '/product/industryEdition',
    name: 'industryEdition',
    component: () => import('../views/product/industryEdition.vue')
  },
  // 碳足迹
  {
    path: '/product/footprint',
    name: 'footprint',
    component: () => import('../views/product/footprint.vue')
  },
  // 城市零碳大脑
  {
    path: '/product/brain',
    name: 'brain',
    component: () => import('../views/product/brain.vue')
  },
  // 园区零碳大脑
  {
    path: '/product/park',
    name: 'park',
    component: () => import('../views/product/park.vue')
  },
  // 新能源电站
  {
    path: '/product/powerStation',
    name: 'powerStation',
    component: () => import('../views/product/powerStation.vue')
  },
  // 林业碳汇
  {
    path: '/product/forestry',
    name: 'forestry',
    component: () => import('../views/product/forestry.vue')
  },
  // 碳立方的优势
  {
    path: '/product/advantage',
    name: 'advantage',
    component: () => import('../views/product/advantage.vue')
  },
  // 联系我们
  {
    path: '/product/Contact',
    name: 'Contact',
    component: () => import('../views/product/Contact.vue')
  }
]

const router = new VueRouter({
  routes,
  ignoreDuplicates: true
})

export default router
